import React, { useState, useEffect } from 'react';
import './DebugLogs.css';

const DebugLogs = () => {
  const [logs, setLogs] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Récupérer les logs depuis sessionStorage
    const updateLogs = () => {
      try {
        const savedLogs = sessionStorage.getItem('debug_logs');
        if (savedLogs) {
          setLogs(JSON.parse(savedLogs));
        }
      } catch (e) {
        console.error('Erreur lors de la récupération des logs:', e);
      }
    };

    // Mettre à jour les logs toutes les secondes
    updateLogs();
    const interval = setInterval(updateLogs, 1000);

    return () => clearInterval(interval);
  }, []);

  if (logs.length === 0) {
    return null;
  }

  return (
    <div className={`debug-logs-container ${isVisible ? 'visible' : ''}`}>
      <button 
        className="debug-logs-toggle"
        onClick={() => setIsVisible(!isVisible)}
      >
        {isVisible ? '🔼' : '🔽'} Logs ({logs.length})
      </button>
      {isVisible && (
        <div className="debug-logs-content">
          <div className="debug-logs-header">
            <h3>📋 Logs de débogage</h3>
            <button onClick={() => {
              sessionStorage.removeItem('debug_logs');
              setLogs([]);
            }}>
              🗑️ Vider
            </button>
          </div>
          <div className="debug-logs-list">
            {logs.slice(-20).reverse().map((log, index) => (
              <div key={index} className="debug-log-entry">
                <div className="debug-log-time">
                  {new Date(log.timestamp).toLocaleTimeString()}
                </div>
                <div className="debug-log-message">{log.message}</div>
                {log.data && (
                  <pre className="debug-log-data">{log.data}</pre>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DebugLogs;

